
import React, { useEffect, useState } from 'react';
import { Space, Button, Modal, notification, Card, Layout, Input, DatePicker } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { FORMAT_DATE_TIME_API, PAGINATION_SIZE } from '../Utils/Constans';
import { deleteEntry, getEntriesForm } from '../Services/DataService';
import { ArrowLeftOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import EntriesListContainer from '../Containers/EntriesListContainer';
import EntryDetailsContainer from '../Containers/Entries/EntryDetailsContainer';
import moment from 'moment';

const { Content } = Layout;
const { confirm } = Modal;
const { RangePicker } = DatePicker;

const EntriesTablePage = () => {
  const [data, setData] = useState([])
  const [dataColumn, setDataColumn] = useState([])
  const [pageSize, setPageSize] = useState(PAGINATION_SIZE)
  const [totalData, setTotalData] = useState(0)
  const [showDetail, setShowDetail] = useState(false)
  const [dataDetails, setDataDetails] = useState([])
  const [headerData, setHeaderData] = useState()
  const [searchValue, setSearchValue] = useState('')
  const [loadingSearch, setLoadingSearch] = useState(false)

  const [startDate, setStartDate] = useState()
  const [endDate, setEndtDate] = useState()

  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    fetchEntriesData(1, pageSize, '')
  }, [id])

  useEffect(() => { onClickSearchValue() }, [startDate, endDate]);

  const fetchEntriesData = async (page, size, searchValue) => {
    setLoadingSearch(true)
    try {
      var param = {
        page: page,
        size: size,
        searchValue: searchValue,
        formId: id,
        startDate: startDate,
        endDate: endDate
      }

      const resp = await getEntriesForm(param)

      if (resp?.data?.success) {
        resp?.data?.payload?.items.forEach(item => {
          item.key = item.id
        })

        const keys = {}

        if (resp?.data?.payload?.items?.length > 0) {
          resp.data.payload.items[0].formHeader?.formDetails?.forEach(detail => {
            keys[detail.key] = detail.placeholder
          })
        }

        const mappedKeys = Object.keys(keys).map(key => {
          return {
            title: keys[key],
            dataIndex: key,
            key: key,
            render: (text) => <>{text}</>,
          }
        })
        
        mappedKeys.push({
          title: 'Action',
          key: 'action',
          render: (_, record) => (
            <Space size="middle">
              <Button onClick={() => onClickShowDetails(record)} >Details</Button>
              <Button onClick={() => showDeleteConfirm(record.id)}>Delete</Button>
            </Space>
          ),
        })

        const mappedItems = []
        resp?.data?.payload?.items?.forEach(item => {
          const contentData = JSON.parse(item.content)
          Object.keys(contentData).forEach(key => {
            const originVal = contentData[key]
            const mappedKey = Object.keys(keys).find(srcKey => keys[srcKey] === key)
            if (mappedKey) {
              delete contentData[key]
              // issue for upload file field. it returns object if empty and this will result rendering error
              contentData[mappedKey] = typeof(originVal) === 'object' ? JSON.stringify(originVal) : originVal
            }
          })
          mappedItems.push({
            ...item,
            ...contentData
          })
        })
        setData(mappedItems)
        setTotalData(resp?.data?.payload?.totalItems)

        resp?.data?.payload?.items.forEach(element => {
          setDataColumn(mappedKeys)

        })
      }

    } catch (e) {
      notification.error({ message: e.message })
      console.log('error', e)
    }
    setLoadingSearch(false)
  }

  const onChangePage = (page, size) => {
    setPageSize(size)
    fetchEntriesData(page, size, '');
  };

  const onClickShowDetails = (record) => {

    var jsonData = JSON.parse(record.content)

    let arrData = []

    for (var i in jsonData) {
      const val = jsonData[i]
      arrData.push({
        key: i,
        value: typeof(val) === 'object' ? JSON.stringify(val) : val,
      })
    }

    setHeaderData(record)

    setDataDetails(arrData)

    setShowDetail(!showDetail)
  };

  const onCloseDetails = () => {

    setShowDetail(!showDetail)
  };

  const onDeleteEntry = async (id) => {
    try {
      const resp = await deleteEntry(id);

      if (resp?.data?.success) {
        notification.success({ message: 'dataDeletedNotification' })
        fetchEntriesData(1, pageSize, '');
      } else {

        notification.error({ message: (resp?.data?.errors ?? []).join(' \n') })
      }
    } catch (e) { }
  }

  const showDeleteConfirm = (entryId) => {
    confirm({
      title: 'Delete Entry',
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure delete this entry ?`,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {

        onDeleteEntry(entryId)
      },
      onCancel() {
        console.log('Cancel')
      },
    });
  };

  const onChangeSearchValue = (value) => { setSearchValue(value.target.value) }

  const onClickSearchValue = () => {
    fetchEntriesData(1, pageSize, searchValue);
  }

  const onChangeDateRangeValue = (value) => {
    if (value !== null) {
      const valueOfInput1 = moment(value[0]).format(FORMAT_DATE_TIME_API);
      const valueOfInput2 = moment(value[1]).format(FORMAT_DATE_TIME_API);
      setStartDate(valueOfInput1)
      setEndtDate(valueOfInput2)
    }
    else {
      setStartDate(null)
      setEndtDate(null)
    }
  }


  return (
    <Layout>
      <Content className='site-layout-content' style={{ padding: '50px' }}>
        <Card size="small" title="Entries" extra={<Button onClick={() => navigate("/formlist")}><ArrowLeftOutlined /></Button>}>

          {!showDetail &&
            <Space size="middle">
              <RangePicker format={FORMAT_DATE_TIME_API} onChange={onChangeDateRangeValue} />
              <Input.Search
                // allowClear
                // style={{
                //   width: '20%',
                // }}
                value={searchValue}
                onChange={onChangeSearchValue}
                loading={loadingSearch}
                onSearch={() => onClickSearchValue()}

              />
            </Space>
          }





          {!showDetail &&
            <EntriesListContainer
              dataSource={data}
              dataColumn={dataColumn}
              pageSize={pageSize}
              totalData={totalData}
              onChangePage={onChangePage}
            />
          }
        </Card>

        {showDetail &&
          <EntryDetailsContainer
            onClose={onCloseDetails}
            sourceData={dataDetails}
            headerData={headerData}
          />
        }

      </Content>
    </Layout>

  );
};

export default EntriesTablePage;